import React, {memo, useCallback} from 'react';
import {onClickHandler} from '../../../utils/onclick';
import {useQuestion} from '../../../hooks/question';
import {useRelations} from '../../../hooks/relations';
import {useLocalization} from "../../../hooks/localization";

type Props = {
    id: string;
    type: string;
    questionText: string;
    questionTextRelational: (message:string) => string;
    onPress: () => void;
}

export const SettingsDeleteButton = memo(function SettingsDeleteButton({onPress: onPressProp, id, type, questionText, questionTextRelational}: Props) {
    const {t} = useLocalization();
    const question = useQuestion();
    const getRelations = useRelations();

    const onPress = useCallback(() => {
        getRelations(id, type)
            .then(([message, positiveButton]) => {
                const questionMessage = message == null ? questionText : questionTextRelational(message);
                question(questionMessage, onPressProp, undefined, positiveButton);
            });
    }, [getRelations, id, onPressProp, question, questionText, questionTextRelational, type]);

    return (
        <div
            className='button mulberry-wood'
            key='delete'
            {...onClickHandler(onPress)}>
                <span className='time'>
                    {t('delete')}
                </span>
        </div>
    );
});
